<template>
  <div>
    <div class="upload">
    <el-upload
      class="element-form-upload-demo"
      :action="uploadUrl"
      :accept="accept"
      :show-file-list="false"
      element-loading-text="上传中，请稍后……"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeUpload"
    >
    <slot name="upload-icon"></slot>
    <!-- <span v-if="imageUrl" >
      <slot name="img"></slot>
    </span>
      <span v-else>
        <slot name="upload-icon">
      </slot>
      </span> -->

    </el-upload>
    <div class="img_div" v-if="imageUrl">
        <div class="mask">
          <div class="mask-button">
            <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(imageUrl)">
              <i class="el-icon-view"></i>
            </span>
            <span class="el-upload-list__item-preview" @click="handleRemove(imageUrl)">
              <i class="el-icon-delete"></i>
            </span>
          </div>
        </div>
    </div>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imageUrl: '',
      dialogImageUrl: '',
      dialogVisible: false
    }
  },
  props: {
    uploadUrl: {
      type: String
    },
    accept: {
      type: String
    },
    beforeAvatarUpload: {
      type: Function
    }
  },
  methods: {
    async beforeUpload(file) {
      let rules = false
      let fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      rules = this.beforeAvatarUpload(file, fileType)
      if (!rules) {
        return Promise.reject()
      }
      return Promise.resolve()
    },
    handleAvatarSuccess(res, file) {
      this.$emit('handleAvatarSuccess', res, file)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file
      this.dialogVisible = true
    },
    handleRemove(file) {
      this.imageUrl = ''
      this.$emit('image-url', this.imageUrl)
    }
  }
}
</script>
<style lang="stylus" scoped>
.upload {
  position: relative;
  height: 100%
}
.element-form-upload-demo >>>.el-upload:hover {
  border-color #ff8b00
}
.element-form-upload-demo{
  height 100%
  >>>.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    height: 100%;
    width:100%
  }
  .el-icon-upload {
    font-size: 40px;
    color: rgba(255, 139, 0, 0.5);
  }

  .el-upload__text {
    color: #999;
  }

  >>>.el-upload__tip {
    margin: 0;
  }
}
.img_div {
  // position: relative;
  height: 100%;
  // width: 104px;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(101, 101, 101, 0.6);
  color: #fff;
  opacity: 0;
}

.mask-button {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.img_div:hover .mask {
  opacity: 1;
}
>>>.el-upload-list__item-preview {
  padding 0px 5px
}
>>>.el-upload-list__item-preview i {
  cursor pointer
}
</style>
